import Image from 'next/image';
import React, { JSX } from 'react';
import { Folder } from 'stockblocks-client';

type Props = {
    bin: Folder;
    existsInBin: boolean;
    handleBinClick: (evt: React.MouseEvent | React.KeyboardEvent, bin: Folder) => void;
    isShared: boolean;
};

const FolderCard = ({ bin, existsInBin = false, handleBinClick, isShared = false }: Props): JSX.Element => (
    <div
        role="button"
        tabIndex={0}
        key={`popover-bin-${bin.uniqueId}`}
        data-testid={`popover-bin-${bin.uniqueId}`}
        className="binPopoverCard hover:bg-gray-100 flex-nowrap flex mb-3 text-gray-700 cursor-pointer"
        onClick={(e) => handleBinClick(e as React.MouseEvent, bin)}
        onKeyDown={(e) => {
            if (e.key === 'Enter') {
                handleBinClick(e as React.KeyboardEvent, bin);
            }
        }}
    >
        <Image
            alt="Favorite bin thumbnail"
            className="object-cover w-12 h-12 overflow-hidden align-top bg-gray-200"
            src={bin.thumbnailUrl || getSiteSpecificDefaultImage()}
            height={100}
            width={100}
        />

        <div className="grow inline-block ml-3 my-auto overflow-x-hidden text-left">
            <h4 className="binPopoverCard-name text-ellipsis whitespace-nowrap m-0 overflow-hidden text-sm font-normal">
                {bin.name}
            </h4>
            <p className="m-0 text-xs text-gray-400">
                <span>{bin.itemCount} </span>
                <span>{bin.itemCount === 1 ? 'item' : 'items'}</span>
                {isShared && <span> (Shared)</span>}
            </p>
        </div>

        {existsInBin && (
            <Image
                className="fav-icon bg-none w-6 h-6"
                src="https://d3g7htsbjjywiv.cloudfront.net/assets/common/images/check-mark.svg"
                alt="check mark"
                width={24}
                height={24}
            />
        )}
    </div>
);

export function getSiteSpecificDefaultImage(): string {
    return 'https://d3g7htsbjjywiv.cloudfront.net/assets/common/images/icons/member-bins/empty.svg';
}

export default FolderCard;
